function Timetable() {
  return (
    <>
        <div style={{margin: '20px', fontSize: '25px'}}>
            <center>Full timetable will be uploaded soon...<br></br></center>
        </div>
    </>
  );
}

export default Timetable;
